import React, { memo } from 'react';
import { Grid } from '@mui/material';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';

import { useDispatch } from 'react-redux';
import ListView from '../list-view';
import { NavigateRoutes } from '../../../../constant';
import GridView from '../grid-view';
import LazyTab from '../helpers/lazyTab';
import { colors, fonts } from '../../../../theme';
import { getAllStudentsByAdmin } from '../../../../store/actions/getStudent';
import constant from '../../../../store/constant';

const useStyles = makeStyles(() => ({
  studentContainer: {
    color: colors.black,
    width: 'auto',
    fontFamily: fonts.fontType.roboto,
  },
  studentListView: {
    textAlign: 'center',
    paddingBottom: 20,
  },
  studentTileView: {
    justifyContent: 'center',
    textAlign: 'center',
    paddingBottom: 20,
    marginLeft: '-1vw !important',
  },
}));

function MainView(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    view,
    onUpdateParentClick,
    paymentDialogOpen,
    editExamDetailsOpen,
    onClickMenu,
    onClickCancelEnrollMenu,
    onClickEditExamDetails,
    onEditMenuClick,
    sortModel,
    onSortModelChange,
    setEditStudentProfile,
    setSwapCourseOrLocation,
    setSelectedRecord,
    setIsRecoveryDialogOpen,
    pageNumber,
    pageLimit,
    nextPage,
    setIsFetching,
    isFetching,
    localFilterPayload,
    hasMore,
    setLoading,
    setError,
    selectedFilter,
    setOpenMarksPopUp,
    setDataAssignScore,
    setAssignLoading,
    setLoadingSpinner,
    loadingSpinner,
    filterOptions,
    setSortOrder,
    sortOrder,
    sortBoth,
    setSortBoth,
    setSelected,
    selected,
    studentLoading,
    isSelectAllCheck,
    setSelectAllCheck,
    selectedStudentIds,
    setSelectedStudentIds,
    refSelectedStudentIds,
    setRepeatStatusOpen,
    setUnselectedStudents,
    unselectedStudents,
    refUnSelectedStudentIds,
  } = props;

  const dispatch = useDispatch();
  function loadMoreItems(students) {
    setIsFetching(true);
    if (Object.keys(localFilterPayload.filters).length === 0) {
      return;
    }
    dispatch(getAllStudentsByAdmin(pageNumber, 100, nextPage, setLoading, students, localFilterPayload));
  }
  return (
    <Grid container className={classes.studentContainer}>
      {view === 'listView' ? (
        <LazyTab>
          <Grid container className={classes.studentListView}>
            <ListView
              {...{
                onUpdateParentClick,
                paymentDialogOpen,
                editExamDetailsOpen,
                onClickMenu,
                onClickCancelEnrollMenu,
                onClickEditExamDetails,
                onEditMenuClick,
                sortModel,
                onSortModelChange,
                setEditStudentProfile,
                setSwapCourseOrLocation,
                pageLimit,
                pageNumber,
                isFetching,
                hasMore,
                setIsFetching,
                nextPage,
                loadMoreItems,
                setError,
                selectedFilter,
                setOpenMarksPopUp,
                setDataAssignScore,
                setAssignLoading,
                setLoadingSpinner,
                loadingSpinner,
                filterOptions,
                setSortOrder,
                studentLoading,
                sortOrder,
                sortBoth,
                setSortBoth,
                setSelected,
                selected,
                setRepeatStatusOpen,
                setSelectAllCheck,
                setUnselectedStudents,
                unselectedStudents,
              }}
              type="list"
              recoveryDialogOpen={(row) => {
                setSelectedRecord(row);
                setIsRecoveryDialogOpen(true);
              }}
              showStudentLogs={(row) => {
                dispatch({
                  type: constant.SET_VIEW,
                  payload: 'cardView',
                });
                navigate(NavigateRoutes.STUDENTS_LOGS, {
                  state: { id: _.get(row, 'userId', ''), lastRoute: NavigateRoutes.STUDENTS_VIEW },
                });
              }}
            />
          </Grid>
        </LazyTab>
      ) : (
        <LazyTab>
          <Grid container className={classes.studentTileView}>
            <GridView
              {...{
                isSelectAllCheck,
                setSelectAllCheck,
                onUpdateParentClick,
                paymentDialogOpen,
                editExamDetailsOpen,
                onClickMenu,
                onClickCancelEnrollMenu,
                onClickEditExamDetails,
                onEditMenuClick,
                setEditStudentProfile,
                setSwapCourseOrLocation,
                pageLimit,
                pageNumber,
                isFetching,
                hasMore,
                setIsFetching,
                nextPage,
                loadMoreItems,
                setError,
                selectedFilter,
                filterOptions,
                studentLoading,
                selectedStudentIds,
                setSelectedStudentIds,
                refSelectedStudentIds,
                setRepeatStatusOpen,
                setSelected,
                setUnselectedStudents,
                unselectedStudents,
                refUnSelectedStudentIds,
              }}
              type="grid"
              recoveryDialogOpen={(row) => {
                setSelectedRecord(row);
                setIsRecoveryDialogOpen(true);
              }}
              showStudentLogs={(row) => {
                dispatch({
                  type: constant.SET_VIEW,
                  payload: 'cardView',
                });
                navigate(NavigateRoutes.STUDENTS_LOGS, {
                  state: { id: _.get(row, 'userId', ''), lastRoute: NavigateRoutes.STUDENTS_VIEW },
                });
              }}
            />
          </Grid>
        </LazyTab>
      )}
    </Grid>
  );
}

export default memo(MainView);
